import React, { Component } from 'react';

import styles from '../../static/css/pageStyleModules/firstView.module.scss';

import logoMark from '../../static/img/logo_and_mark.svg';

export default class FirstView extends Component {
    render(){
        return (
          <div className={styles['firstViewWholeArea']}> 
            <img src={logoMark} alt="logo"/>
          </div>
        )
    }
}
